/**
 * BrothersInCards Live Stream Widget Controller Script
 * Created by Mattie 07/08/2026
 * v1.0
 */

(function () {
  'use strict';

  var COOKIE_SESSION_NAME = 'bic_hide_widget';
  var COOKIE_DISMISS_24H_NAME = 'bic_dismiss_forever';
  var SECONDS_24H = 86400; // 24 hours

  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? match[2] : null;
  }

  function setCookie(name, value, maxAgeSeconds) {
    if (maxAgeSeconds) {
      document.cookie = name + '=' + value + '; path=/; max-age=' + maxAgeSeconds + '; SameSite=Lax';
    } else {
      document.cookie = name + '=' + value + '; path=/; SameSite=Lax';
    }
  }

  function hasAnalyticsConsent() {
    // Check Shopify Customer Privacy API consent if present
    if (window.Shopify && window.Shopify.customerPrivacy && typeof window.Shopify.customerPrivacy.getTrackingConsent === 'function') {
      return window.Shopify.customerPrivacy.getTrackingConsent() === 'yes';
    }
    return true;
  }

  function sendClickPing(platform, endpoint) {
    if (!endpoint) {
      console.log('[BIC Stream Widget] No click tracker endpoint configured. Skipping ping.');
      return;
    }
    if (!hasAnalyticsConsent()) {
      console.log('[BIC Stream Widget] Analytics consent not given. Skipping ping.');
      return;
    }

    var payload = JSON.stringify({
      platform: platform || 'unknown',
      timestamp: new Date().toISOString()
    });

    console.log('[BIC Stream Widget] Sending click ping:', { platform: platform, endpoint: endpoint, payload: payload });

    try {
      if (navigator.sendBeacon) {
        var blob = new Blob([payload], { type: 'application/json' });
        navigator.sendBeacon(endpoint, blob);
      } else {
        fetch(endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: payload,
          keepalive: true
        });
      }
    } catch (err) {
      console.warn('[BIC Stream Widget] Click ping error:', err);
    }
  }

  function initStreamWidget() {
    var widgetEl = document.getElementById('bic-stream-widget');
    if (!widgetEl) {
      console.log('[BIC Stream Widget] #bic-stream-widget element not found on page.');
      return;
    }

    console.log('[BIC Stream Widget] Initializing stream widget...');

    var toggleBtn = widgetEl.querySelector('.bic-stream-widget__toggle-btn');
    var toggleMinus = widgetEl.querySelector('.bic-stream-widget__toggle-minus');
    var togglePlus = widgetEl.querySelector('.bic-stream-widget__toggle-plus');

    function setMinimizedState(minimized) {
      if (minimized) {
        widgetEl.classList.add('is-minimized');
        widgetEl.classList.remove('is-expanded');
        if (toggleMinus && togglePlus) {
          toggleMinus.style.display = 'none';
          togglePlus.style.display = 'inline-block';
        }
      } else {
        widgetEl.classList.remove('is-minimized');
        widgetEl.classList.add('is-expanded');
        if (toggleMinus && togglePlus) {
          toggleMinus.style.display = 'inline-block';
          togglePlus.style.display = 'none';
        }
      }
    }

    var isMobileWindow = window.innerWidth <= 768;
    if (widgetEl.classList.contains('is-offline') || isMobileWindow) {
      setMinimizedState(true);
    }

    if (toggleBtn) {
      toggleBtn.addEventListener('click', function (evt) {
        evt.preventDefault();
        evt.stopPropagation();
        var currentlyMinimized = widgetEl.classList.contains('is-minimized');
        console.log('[BIC Stream Widget] Toggle button clicked. Setting minimized state to:', !currentlyMinimized);
        setMinimizedState(!currentlyMinimized);
      });
    }

    var closeSessionBtn = widgetEl.querySelector('.bic-stream-widget__close-session-btn');
    if (closeSessionBtn) {
      closeSessionBtn.addEventListener('click', function (evt) {
        evt.preventDefault();
        evt.stopPropagation();
        console.log('[BIC Stream Widget] Dismissing widget for current session...');
        try {
          sessionStorage.setItem('bic_hide_widget', '1');
        } catch(e) {}
        setCookie(COOKIE_SESSION_NAME, '1');
        widgetEl.classList.add('is-hidden');
      });
    }

    function cleanHostname(host) {
      if (!host) return '';
      return host.replace(/^https?:\/\//i, '').split('/')[0].split(':')[0];
    }

    var playTrigger = widgetEl.querySelector('.bic-stream-widget__play-trigger');
    if (playTrigger) {
      function handlePlayTrigger(evt) {
        if (evt) {
          evt.preventDefault();
          evt.stopPropagation();
        }

        var channel = playTrigger.getAttribute('data-channel');
        var domain = playTrigger.getAttribute('data-domain') || window.location.hostname;
        var permDomain = playTrigger.getAttribute('data-permanent-domain') || domain;
        var container = document.getElementById('bic-preview-container');

        console.log('[BIC Stream Widget] Play trigger invoked:', { channel: channel, domain: domain, permDomain: permDomain, location: window.location.hostname });

        if (channel && container) {
          widgetEl.classList.add('is-playing');
          widgetEl.classList.add('is-expanded');

          var currentHost = cleanHostname(window.location.hostname);
          var domainHost = cleanHostname(domain);
          var permHost = cleanHostname(permDomain);

          var parentHosts = [currentHost];
          if (domainHost && parentHosts.indexOf(domainHost) === -1) parentHosts.push(domainHost);
          if (permHost && parentHosts.indexOf(permHost) === -1) parentHosts.push(permHost);

          var parentQuery = parentHosts.map(function (h) {
            return '&parent=' + encodeURIComponent(h);
          }).join('');

          var isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || window.innerWidth <= 768;
          var muteParam = isMobile ? 'true' : 'false';

          var playerUrl = 'https://player.twitch.tv/?channel=' + encodeURIComponent(channel) +
            parentQuery +
            '&autoplay=true&muted=' + muteParam;

          console.log('[BIC Stream Widget] Embedding Twitch player URL:', playerUrl);

          var iframe = document.createElement('iframe');
          iframe.setAttribute('src', playerUrl);
          iframe.setAttribute('id', 'bic-twitch-iframe');
          iframe.setAttribute('height', '180');
          iframe.setAttribute('width', '320');
          iframe.setAttribute('allow', 'autoplay; fullscreen');
          iframe.setAttribute('allowfullscreen', 'true');
          iframe.setAttribute('class', 'bic-stream-widget__iframe-player');
          iframe.setAttribute('title', 'Twitch Live Stream Video Player');

          container.innerHTML = '';
          container.appendChild(iframe);
          console.log('[BIC Stream Widget] Twitch player iframe embedded successfully (#bic-twitch-iframe).');
        }
      }

      playTrigger.addEventListener('click', handlePlayTrigger);
    }

    var ctaBtn = widgetEl.querySelector('.bic-stream-widget__cta-btn');
    if (ctaBtn) {
      ctaBtn.addEventListener('click', function (evt) {
        if (window.innerWidth <= 768 && !widgetEl.classList.contains('is-expanded') && !widgetEl.classList.contains('is-playing')) {
          evt.preventDefault();
          console.log('[BIC Stream Widget] Mobile CTA tapped. Expanding widget preview...');
          widgetEl.classList.add('is-expanded');
          return;
        }

        var platform = ctaBtn.getAttribute('data-platform') || 'stream';
        var endpoint = ctaBtn.getAttribute('data-tracker-endpoint') || '';

        console.log('[BIC Stream Widget] CTA button clicked:', { platform: platform, endpoint: endpoint, href: ctaBtn.getAttribute('href') });
        sendClickPing(platform, endpoint);

        if (hasAnalyticsConsent() && window.gtag) {
          console.log('[BIC Stream Widget] Triggering Analytics event stream_widget_click.');
          window.gtag('event', 'stream_widget_click', {
            event_category: 'engagement',
            event_label: ctaBtn.getAttribute('href')
          });
        }
      });
    }

    widgetEl.addEventListener('click', function (evt) {
      if (evt.target.closest('.bic-stream-widget__action-btn') || 
          evt.target.closest('.bic-stream-widget__play-trigger') || 
          evt.target.closest('.bic-stream-widget__platform-icon-btn') ||
          evt.target.closest('.bic-stream-widget__header-social-btn') ||
          evt.target.closest('.bic-stream-widget__cta-btn')) {
        return;
      }
      var isCurrentlyMinimized = widgetEl.classList.contains('is-minimized');
      console.log('[BIC Stream Widget] Widget clicked/tapped. Toggling minimized state to:', !isCurrentlyMinimized);
      setMinimizedState(!isCurrentlyMinimized);
    });

    document.addEventListener('click', function (evt) {
      if (!widgetEl.contains(evt.target) && !widgetEl.classList.contains('is-minimized') && window.innerWidth <= 768) {
        console.log('[BIC Stream Widget] Clicked outside expanded mobile widget. Minimizing...');
        setMinimizedState(true);
      }
    });

    console.log('[BIC Stream Widget] Widget successfully initialized on page.', widgetEl);
  }

  console.log('[BIC Stream Widget] Controller script loaded.');

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStreamWidget);
  } else {
    initStreamWidget();
  }
})();
